export const selectGroupsList = (state) => state.groups.groups;
export const selectGroupsLoading = (state) => state.groups.loading;
export const selectGroupsError = (state) => state.groups.error;
export const selectGroupsSuccessMessage = (state) => state.groups.successMessage;
export const selectSelectedGroup = (state) => state.groups.selectedGroup;
export const selectIsEditGroup = (state) => state.groups.isEditGroup;
